import httpService from "../../Service/httpService";

const controller = "Consultas";

export const getHorariosServicio = async (id, f1, f2, filtro) => {
  const res = await httpService.get(
    `/${controller}/getHorariosServicio/${id}/${f1}/${f2}/${filtro}`
  );
  return res.data;
};


export const saveHorario = async (data) => {
  //   const userData = getDecodedToken();
  const res = await httpService.post(`/${controller}/saveHorario`, {
    ...data,
  });
  return res;
};

export const cancelHorario = async (data) => {
  //   const userData = getDecodedToken();
  const res = await httpService.post(`/${controller}/cancelHorario`, {
    ...data,
  });
  return res;
};

export const eliminaHorarios = async (data) => {
  //   const userData = getDecodedToken();
  const res = await httpService.post(`/${controller}/eliminaHorarios`, {
    ...data,
  });
  return res;
};


